import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { NEW_ITEMS } from "./newItems";
import { useProjects } from "../../../projects/projectContext";
import { appPaths } from "../../../shared/routing/appPaths";
import AppButton from "../../../ui/buttons/AppButton";
import { useHerePath, useThreadPreparation } from "../../threads/prepare";

/**
 * `/workflows` (F36, SB-19): no library page. The sidebar lists the Workflows, the one
 * place to browse them; a Workflow's view shows its steps and, under Resources and
 * context, the items they read. This page says so and offers what can be made new: "New …"
 * prepares it in the Thread view, by hand in its form where it has one or with the agent (F37).
 */
export default function WorkflowsIndexPage() {
  const { t } = useTranslation();
  const headingId = useId();
  const projectId = useProjects().selectedProjectId;
  const preparation = useThreadPreparation();
  const here = useHerePath();
  return (
    <div className="mx-auto max-w-3xl space-y-4 py-4">
      <h2 className="app-title text-xl font-bold">{t("sections.workflows")}</h2>
      {projectId === null ? (
        <Link to={appPaths.projects()} className="app-link text-sm underline">{t("projects.needed.title")}</Link>
      ) : (
        <>
          <p className="app-text-muted text-sm">{t("workflows.index.intro")}</p>
          <section className="app-card space-y-2 p-4" aria-labelledby={headingId}>
            <h3 id={headingId} className="app-title text-sm font-semibold">{t("workflows.index.new")}</h3>
            <div className="flex flex-wrap gap-2">
              {NEW_ITEMS.map((item) => (
                <AppButton key={item.key} variant="secondary" size="sm" onClick={() => { preparation.prepare({ kind: "author", projectId, returnTo: here, itemKind: item.kind, draft: null, name: "" }); }}>
                  {t(`authoring.library.new.${item.key}`)}
                </AppButton>
              ))}
            </div>
          </section>
        </>
      )}
    </div>
  );
}
